import { IAlbum } from 'redhotpie-shared-lib/interfaces/IImages';
import * as utils from '../functions/utils';

interface AlbumData {
  GalleryID: number;
  Name: string;
  IsPublic: boolean;
  ImageCount: number;
  HasAccess: boolean;
  HasRestricted: boolean;
  ExpiryDateUTC: string;
}

export default class Album {
  galleryId: number;
  name: string;
  isPublic: boolean;
  imageCount: number;
  isGranted: boolean;
  hasAccess: boolean;
  hasRestricted: boolean;
  expiredTime: string;

  constructor() {
    this.galleryId = 0;
    this.name = '';
    this.isPublic = false;
    this.imageCount = 0;
    this.isGranted = false;
    this.hasAccess = false;
    this.expiredTime = '';
    this.hasRestricted = false;
  }

  static mappingObject(_album: AlbumData): IAlbum {
    let album = Object.assign(new Album(), _album);
    album.galleryId = _album.GalleryID;
    album.name = `${_album.Name}`;
    album.isPublic = _album.IsPublic;
    album.imageCount = _album.ImageCount;
    album.hasRestricted = _album.HasRestricted || false;
    album.isGranted = _album.HasAccess || false;
    album.hasAccess = _album.HasAccess || false; // using this field to check access to private album. will remove isGranted in future
    album.expiredTime = _album.ExpiryDateUTC;

    album = utils.cleanObjectKeys(Object.keys(new Album()), album); // clean other key doesn't exist in user model
    return album;
  }

  static mappingObjects(_albums: AlbumData[]): IAlbum[] {
    const albums: IAlbum[] = [];
    _albums.forEach(_album => {
      const album = Album.mappingObject(_album);
      albums.push(album);
    });

    return albums;
  }
}
